import { Component, OnInit } from '@angular/core';
import { LoadingScreen } from './shared/interfaces/loading-screen.interface';
import { ContentService } from './shared/services/';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  clientHeight: number;

  loadingIconPath = 'assets/images/animations/';
  loadingScreen: LoadingScreen;
  //translate:TranslateService;
  constructor(public contentService: ContentService, translate:TranslateService) {
    const html = document.querySelector('html');
    translate.addLangs(['ar', 'en']);
    let currentLanguage =localStorage.getItem('currentLanguage');
    if(currentLanguage==null){
      translate.setDefaultLang('en');
      translate.use('en');
    }
    else{
      translate.setDefaultLang(currentLanguage);
      translate.use(currentLanguage);
    }
    
      html.setAttribute(
        'dir',
        currentLanguage=='ar' ? 'rtl' : 'ltr'
      );
    
    //const browserLang = translate.getBrowserLang();
    //translate.use(browserLang.match(/en|ar/) ? browserLang : 'ar');
    //translate.currentLang='ar';
   // translate.use('ar');
    this.clientHeight = window.innerHeight;
  }

  ngOnInit() {
    this.contentService.loadingScreen$.subscribe(
      loadingScreenData => {
        if (loadingScreenData) {
          this.loadingScreen = loadingScreenData;
        }
      }
    );
   // this.translate.use('ar');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts